<template>
  <div class="container-fluid">
    <div class="row">
    
      <div class="col-sm-3"></div>

      <div class="col-sm-6">
      <Header></Header>
      <br><br>
          <h3 class="alert alert-success">
                Hartelijk dank voor je bestelling!
          </h3>
          <br>
            <div class="alert alert-success">
                <p>Het rapport wordt verzonden als de betaling is goedgekeurd. Je ontvangt waarschijnlijk binnen 5 minuten een email op het opgegeven emailadres met het rapport als bijlage. Heb je via creditcard betaald, dan kan het soms wat langer duren.<br>
                Mocht je de email niet kunnen vinden, kijk dan eerst in de spam folder.<br>
                Is ook daar de mail niet ontvangen, neem dan contact op via info@rightlaneproductions.eu</p>
            </div>
      </div>
        
      <div class="col-sm-3"></div>
    </div>

  </div>
</template>

<script>
import Header from './Header.vue';

export default {
  name: 'thankyou',
  props: {
    msg: String
  },
  components: {
    Header,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    height: 100%;
    background-color:#000a3f;
}
h3 {
  margin: 80px 0 0;
  font-size:2.5em;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
